import { DOMHelper } from '../../Helpers/DOMHelper.js';

export class DynamicList {

	/**
	 * stepper config
	 * @param  FrontApp app      parent to access all other objects in the project
	 * @param  String elementId  dom element ID that shows up the popup on click
	 * @param  String htmlItemTemplate  html for each element in the list
	 * @param  String addBtnLabel text in button for add, html allowed
	 */
	constructor(app, elementId, htmlItemTemplate, addBtnLabel){
		this.app = app;				
		this.elementId = elementId;		
		this.rootElement = document.querySelector(this.getSelector(''));		
		this.htmlItemTemplate = htmlItemTemplate;		
		this.addBtnLabel = addBtnLabel;		
		this.itemsCount = 0;		
		this.nextIndex = 0;		
	}


	addHtml(){				
		let content = `
		<div class="pmdrs-dynamic-list">
			<div class="pmdrs-dl-items">

			</div>
			<button type='button' class="pmdrs-dl-add-btn" >
				`+ this.addBtnLabel +`
			</button>
		</div>
		`;

		this.rootElement.innerHTML = content;				
	}

	getItemHTML(index){
		return `<div class="pmdrs-dl-item" data-index=${index}> ` 
			+ "<div>" + this.makeItemTemplate(index) + "</div>"			
			+ `<button type='button' class="pmdrs-dl-remove-btn pmdrs-c-2" data-index=${index}>x</button>`
			+ `</div>`
	}

	init() {
		this.addHtml();
		this.addHandlers();		
		this.addItem();
	}
	
	addHandlers(){
		let thisDL = this;

		DOMHelper.addHandler(this.getSelector(".pmdrs-dl-remove-btn"), 'click', function (){	
			thisDL.removeItem(this.dataset['index']);
		});
		
		DOMHelper.addHandler(this.getSelector(".pmdrs-dl-add-btn"), 'click', function (){				
			thisDL.addItem();
		});

	}

	/**
	 * [makeItemTemplate replace {params} with values, eg index]
	 * @param  Integer index of the item 
	 * @return String with the template        [description]
	 */
	makeItemTemplate(index){
		return this.htmlItemTemplate.replaceAll("{index}", index);	
	}

	removeItem(index){
		let item = document.querySelector(this.getSelector(".pmdrs-dl-item[data-index='"+index+"']"));
		item.remove();
		this.itemsCount--;
	}

	addItem(){
		var thisDL = this;

		var newIndex = this.nextIndex++;
		let itemsContainer = document.querySelector(this.getSelector('.pmdrs-dl-items'));		
		itemsContainer.insertAdjacentHTML('beforeend', this.getItemHTML(newIndex));
		this.itemsCount++;

		//add handler
		let allRemoveBtns = document.querySelectorAll(this.getSelector(".pmdrs-dl-remove-btn"))
		let lastBtn = allRemoveBtns[allRemoveBtns.length - 1];
		DOMHelper.addHandler(lastBtn, 'click', function(){
			thisDL.removeItem(newIndex);
		});
	}

	getSelector(selector) {
		return this.app.getSelector("#"+this.elementId + " " + selector);
	}
}